import { useEffect, useState } from "react"

import { loadFlags } from "./loadFlags"

const CountryFlag = ({ iso }) => {
  const [flags, setFlags] = useState(null)

  useEffect(() => {
    let active = true
    loadFlags().then((mod) => active && setFlags(mod))
    return () => {
      active = false
    }
  }, [])

  const Flag = flags?.[String(iso || "").toUpperCase()]

  return <span className="pc-flag">{Flag ? <Flag title={iso} /> : null}</span>
}

export default CountryFlag
